import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  itemContainer: {
    fontSize: theme.typography.caption.fontSize,
    flexDirection: 'column',
    alignItems: 'stretch'
  },
  labelRow: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    justifyContent: 'flex-start',
    alignItems: 'baseline',
    backgroundColor: 'unset',
    height: 'auto',
    width: 165
  },
  atDivider: {
    color: theme.palette.text.secondary,
    margin: theme.spacing(0, 0.5)
  },
  rangeItem: {
    padding: theme.spacing(0, 1)
  }
}));

export const useLoadingStyles = makeStyles(theme => ({
  root: {
    '& input': {
      color: theme.palette.text.secondary,
      fontSize: theme.typography.caption.fontSize,
      height: '1.1875em',
      padding: theme.spacing(0.5, 0, 0.375),
      '-moz-appearance': 'textfield',
      '&:hover, &:focus': {
        '-moz-appearance': 'number-input'
      }
    },
    fontStyle: ({ isAdjustedLoading }) =>
      isAdjustedLoading ? 'italic' : 'normal'
  },
  loadingPercentLabel: {
    fontSize: theme.typography.caption.fontSize,
    color: theme.palette.text.secondary
  }
}));

export const useQuantityStyles = makeStyles(theme => ({
  root: {
    '& input': {
      color: theme.palette.text.secondary,
      fontSize: theme.typography.caption.fontSize,
      height: '1.1875em',
      padding: theme.spacing(0.5, 0, 0.375),
      '-moz-appearance': 'textfield',
      '&:hover, &:focus': {
        '-moz-appearance': 'number-input'
      }
    },
    width: theme.spacing(12)
  }
}));

export const useStatusStyles = makeStyles(theme => ({
  root: {
    marginLeft: theme.spacing(0.5),
    minWidth: 25
  }
}));

export const useRoleStyles = makeStyles(theme => ({
  icon: {
    display: 'none'
  },
  select: {
    padding: theme.spacing(0.75, 0, 1, 0),
    flexGrow: 1,
    flexShrink: 1,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: 90,
    fontWeight: theme.typography.fontWeightBold,
    fontSize: theme.typography.caption.fontSize
  }
}));

export default useStyles;
